const CHUNK_ERROR_PATTERN =
  /Loading chunk|Failed to fetch dynamically imported module|Failed to load module script|Importing a module script failed/;
const STORAGE_KEY = "eva-chunk-reload";
const MAX_RETRIES = 2;
const RETRY_WINDOW_MS = 60_000;

let reloadInProgress = false;

export function isChunkLoadError(error: unknown): boolean {
  const err = error as { message?: string; rejection?: { message?: string } };
  const message = err?.message || err?.rejection?.message || "";
  return CHUNK_ERROR_PATTERN.test(message);
}

export async function handleChunkLoadError(): Promise<void> {
  if (reloadInProgress) return;
  reloadInProgress = true;

  let state = { count: 0, timestamp: 0 };
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      try {
        state = JSON.parse(raw);
      } catch {
        /* ignore */
      }
    }
  } catch {
    /* SecurityError in private browsing */
  }

  if (Date.now() - state.timestamp > RETRY_WINDOW_MS) {
    state = { count: 0, timestamp: Date.now() };
  }

  if (state.count >= MAX_RETRIES) {
    console.error("[EVA] Nouvelle version disponible. Rechargez la page avec Ctrl+Shift+R.");
    reloadInProgress = false;
    return;
  }

  state.count++;
  state.timestamp = Date.now();
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* SecurityError in private browsing */
  }

  if ("caches" in window) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    } catch {
      /* ignore cache API errors */
    }
  }

  window.location.reload();
}
